<!--
   Created by qing on 2020/9/8
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__item-sign" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>

        <div
          v-if="isRead">
          <el-image class="sign-image" v-if="current.value" :src="current.value"></el-image>
          <span v-else>暂无数据</span>
        </div>
        <div v-if="!isRead">

          <div v-if="!current.value" class="add-sign-btn" @click="addSign">
            <i :class="current.icon"></i>
            <span>添加签名</span>
          </div>

          <div v-else class="sign-show-container" @click="previewSign">
            <el-image class="sign-image" v-if="current.value" :src="current.value"></el-image>
            <el-button v-if="!isReadOnly" type="text" icon="el-icon-delete" @click.stop="deleteSign"></el-button>
          </div>
        </div>

      </template>

    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__item-sign-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div v-if="isRead">
            <el-image class="sign-image" v-if="current.value" :src="current.value"></el-image>
            <span v-else>暂无数据</span>
          </div>
          <div v-else class="sign-compact-container">

            <div v-if="!current.value" class="add-sign-btn" @click="addSign">
              <i :class="current.icon"></i>
              <span>添加签名</span>
            </div>

            <div v-else class="sign-show-container" @click="previewSign">
              <el-image class="sign-image" v-if="current.value" :src="current.value"></el-image>
              <el-button v-if="!isReadOnly" type="text" icon="el-icon-delete" @click.stop="deleteSign"></el-button>
            </div>
          </div>
        </template>
      </van-field>
    </div>

    <van-action-sheet
      get-container="body"
      v-model="showLastSign"
      title="您要使用以下签名吗？">
      <div class="last-sign-container">
        <div class="signature-wrapper" v-if="lastSignInfo && lastSignInfo.signatureUrl">
          <el-image class="last-sign-image" :src="lastSignInfo.signatureUrl"></el-image>
        </div>
        <div class="other-sign-btn" @click="otherSign">
          其他设备签名
        </div>
        <div class="footer">
          <van-button type="default" @click="rewriteSign">重新手写</van-button>
          <van-button type="primary" @click="useLastSign">使用</van-button>
        </div>
      </div>
    </van-action-sheet>

    <van-action-sheet
      get-container="body"
      v-model="otherSignVisible"
      title="请使用其他设备扫码签名">
      <div style="margin: 20px; display: flex; justify-content: center;">
        <vue-qr
          :correctLevel="3"
          :text="qrCodeUrl"
          :size="180"
          :margin="0"
        ></vue-qr>
      </div>
    </van-action-sheet>

    <SignPopup
      :key="signPopKey"
      ref="signPopup"
      :hasOtherSign="true"
      @signSuccess="signSuccess"
      @signCancel="signCancel"
      @otherSign="otherSign"
    ></SignPopup>
  </div>

</template>

<script>
  import {current} from './mixin'
  import SignPopup from "../../component/sign_widget/SignPopup";
  import {ImagePreview} from 'vant'
  export default {
    // /#/3rd_router?key=5f587d12001e3e41aa000cff
    mixins: [current],
    data() {
      return {
        lastSignInfo: {
          hasSignature: 0,
          signatureUrl: ''
        },
        showLastSign: false,
        signKey: '',
        qrCodeUrl: '',
        otherSignVisible: false,
        signPopKey: Math.random(),
      }
    },
    components: {SignPopup},
    created() {
      const formSet = this.current.root
      this.$store.dispatch('actionNodeSave', {
        userId: this.$store.getters.userId,
        companyId: formSet.companyId,
        appId: formSet.appId,
        formId: formSet.formId,
        topic: formSet.tmpTopic,
        fieldId: this.current.dataId,
        subTable: 0,
        rowIdx: 1
      }).then(res => {
        this.signKey = res.nodeKey
      }).catch(console.error)

    },
    computed: {
    },
    methods: {
      // 添加签名
      addSign() {
        if (this.isReadOnly) {
          return
        }
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('actionFormLastSignatureGet')
          .then(res => {
            this.lastSignInfo = res
            if (!this.lastSignInfo || !this.lastSignInfo.hasSignature) {
              if (this.$refs.signPopup) {
                this.$refs.signPopup.open(this.signKey)
              }
            } else {
              this.showLastSign = true
            }
          })
          .catch(console.error)
          .finally(() => {
            toast.clear()
          })
      },
      // 使用上次签名
      useLastSign() {
        this.current.value = this.lastSignInfo.signatureUrl
        this.showLastSign = false
      },

      // 重新签名
      rewriteSign() {
        this.lastSignInfo.hasSignature = 0
        this.lastSignInfo.signatureUrl = ''
        this.showLastSign = false
        if (this.$refs.signPopup) {
          this.$refs.signPopup.open(this.signKey)
        }
      },

      otherSign() {
        const formSet = this.current.root
        this.$store.dispatch('actionNodeSave', {
          userId: this.$store.getters.userId,
          companyId: formSet.companyId,
          appId: formSet.appId,
          formId: formSet.formId,
          topic: formSet.tmpTopic,
          fieldId: this.current.dataId,
          subTable: 0,
          rowIdx: 1
        }).then(res => {
          this.showLastSign = false
          this.otherSignVisible = true
          this.qrCodeUrl = `${location.origin}${this.$MINIAPP_BASE_PATH}/#/sign?key=${res.nodeKey}`
          // this.qrCodeUrl = `http://192.168.0.139:8080/#/sign?key=${res.nodeKey}`
        }).catch(console.error)
      },
      // 删除签名
      deleteSign() {
        this.current.value = ''
      },

      // 预览签名
      previewSign() {
        ImagePreview({
          images: [this.current.value],
          startPosition: 0
        })
      },
      signSuccess() {
        if (this.$refs.signPopup) {
          this.$refs.signPopup.close()
        }
        this.signCancel()
      },
      signCancel() {
        this.signPopKey = Math.random()
      }
    },
    watch: {
      'current.value'() {
        if (this.current.value) {
          this.lastSignInfo.hasSignature = 1
          this.lastSignInfo.signatureUrl = this.current.value
          console.log('watch', this.current.value, this.lastSignInfo)
        }
        this.controlChange()
      }
    }
  }
</script>

<style lang="less">

  .ry-form__item-sign, .ry-form__item-sign-compact {

    .sign-image {
      width: 100px;
      height: 59px;
    }

    .last-sign-image {
      width: 220px;
      height: 130px;
    }

    .add-sign-btn {
      width: 100%;
      height: 34px;
      border: 1px solid #e6e6e6;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      cursor: pointer;

      i {
        margin-right: 10px;
        color: #2D8cF0;
      }
    }

    .sign-show-container {
      width: 100%;
      height: 60px;
      border: 1px solid #e6e6e6;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      position: relative;

      .el-image {
        width: 100px;
        height: 59px;
      }

      .el-button {
        position: absolute;
        right: 40px;
        color: red;
      }
    }

    .sign-compact-container {
      width: 100%;
    }
  }

  .upload-sign-tips {
    font-size: 12px;
    color: #959699;
    text-align: center;
  }

  .last-sign-container {
    .signature-wrapper {
      width: calc(100% - 20px);
      min-height: 160px;
      margin: 10px;
      padding: 10px;
      text-align: center;
      border: 1px solid #D9D9D9;
      border-radius: 3px;

      .el-image {
        width: 100%;
        height: auto;
      }
    }

    .other-sign-btn {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: right;
      color: #05A971;
      padding: 0 20px;
      font-size: 13px;
    }

    .footer {
      height: 44px;
      margin-top: 40px;

      .van-button {
        width: 50%;
      }
    }
  }

  .van-image-preview {
    .van-image-preview__image {
      img {
        background-color: #ffffff;
      }
    }
  }

</style>
